<template>
	<div class="landingpage-banner__container" :style="{height: 'calc(100vh - ' + headerHeight + 'px)'}">
		<div class="landingpage-banner__img-wrapper">
			<img class="landingpage-banner__img" :src="isMobile && imgMobile !== '' ? imgMobile : imgDesktop" :alt="headline">
		</div>
		<div class="landingpage-banner__content-wrapper">
			<h1 class="landingpage-banner__headline" :style="{color: headlineColor}" v-html="headline"></h1>
			<div class="landingpage-banner__txt" v-html="txt"></div>
			<div class="landingpage-banner__btn-wrapper">
				<a v-if="realButtonUrl1 != '' && btnTxt1 != ''" class="landingpage-banner__btn" :class="{'landingpage-banner__btn--primary': btnStyle1 === 'primary', 'landingpage-banner__btn--secondary': btnStyle1 === 'secondary'}" :href="realButtonUrl1">{{ btnTxt1 }}</a>

				<a v-if="realButtonUrl1 != '' && btnTxt2 != ''" class="landingpage-banner__btn" :class="{'landingpage-banner__btn--primary': btnStyle2 === 'primary', 'landingpage-banner__btn--secondary': btnStyle2 === 'secondary'}" :href="realButtonUrl2">{{ btnTxt2 }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		props: {
			imgDesktop: String,
			imgMobile: String,
			headline: String,
			headlineColor: String,
			txt: String,
			btnTxt1: String,
			realButtonUrl1: String,
			btnTxt2: String,
			btnStyle1: String,
			btnStyle2: String,
			realButtonUrl2: String,
		},

		data() {
			return {
			    isMobile: false,
                headerHeight: 0
			}
		},

		mounted(){
			this.isMobile = window.innerWidth < 768;

            this.$nextTick(() => {
                this.headerHeight = document.getElementById("page-header").offsetHeight
            })
		}

	}

</script>
